import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'react-app-polyfill/ie11'


class IntroductionEditor extends React.Component {
  render() {
    // ViewModeコンポーネントに、Rails View の 'react_component' タグで引き渡されたデータを渡す
    // （これらのデータは、それぞれのコンポーネントで 'props' 経由でアクセスできる）
    return (
      <ViewMode
        member={this.props.member}
        errors={this.props.errors}
        update_url={this.props.update_url}
        csrf_token={this.props.csrf_token}
      />
    );
  }
}

class ViewMode extends React.Component {
  // コンストラクタ
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    // デフォルト動作の解除
    e.preventDefault();
    // メッセージエリアをクリア
    var message_area = document.querySelector('div.message_area');
    while (message_area.firstChild) {
      message_area.removeChild(message_area.firstChild);
    }
    // 編集モードに遷移
    ReactDOM.render(
      <EditMode
        member={this.props.member}
        errors={{ pr: '' }}
        update_url={this.props.update_url}
        csrf_token={this.props.csrf_token}
      />,
      document.getElementById('introduction_area')
    );
  }

  render() {
    return (
      <React.Fragment>
        <div className="introduction">
          <h3 className="fs-113">自己紹介・PR</h3>
          <div className="btn_right mypage_introduction edit"><a href="" className="fs-75 btn_target" onClick={this.handleClick}>編集する</a></div>
          <p className="fs-88-custom label_textarea">{this.props.member.pr}</p>
        </div>
      </React.Fragment>
    );
  }
}

class EditMode extends React.Component {
  // コンストラクタ
  constructor(props) {
    super(props);
    this.state = { member: JSON.parse(JSON.stringify(this.props.member)) };
    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleClick(e) {
    // デフォルト動作の解除
    e.preventDefault();
    // ボタン非活性
    let elements = document.querySelectorAll('.btn_target');
    elements.forEach(function (element) {
      element.classList.add('btn_disabled');
    });
    // membersの更新
    fetch(this.props.update_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.props.csrf_token
      },
      body: JSON.stringify({
        associate_member: { pr: this.state.member.pr },
        authenticity_token: this.props.csrf_token
      })
    }).then((res) => {
      return res.json();
    }).then((data) => {
      if (data.status == 200) {
        // ViewModeを再表示
        ReactDOM.render(
          <ViewMode
            member={this.state.member}
            errors={this.props.errors}
            update_url={this.props.update_url}
            csrf_token={this.props.csrf_token}
          />,
          document.getElementById('introduction_area')
        );
        // 変更された項目があるとき
        if (Object.keys(data.saved_changes).length !== 0) {
          // 更新メッセージ表示
          const node = document.createElement('p');
          const message = document.createTextNode('プロフィールを更新しました。');
          node.appendChild(message);
          document.querySelector('div.message_area').appendChild(node);
        }
      } else if (data.status == 400) {
        // メッセージエリアをクリア
        var message_area = document.querySelector('div.message_area');
        while (message_area.firstChild) {
          message_area.removeChild(message_area.firstChild);
        }
        // エラーメッセージとともにEditModeを再表示
        ReactDOM.render(
          <EditMode
            member={this.state.member}
            errors={data.errors}
            update_url={this.props.update_url}
            csrf_token={this.props.csrf_token}
          />,
          document.getElementById('introduction_area')
        );
        // エラーメッセージ表示
        const node = document.createElement('p');
        const message = document.createTextNode('入力内容にエラーがあります。');
        node.appendChild(message);
        document.querySelector('div.message_area').appendChild(node);
      }
      // ボタン活性
      let elements = document.querySelectorAll('.btn_target');
      elements.forEach(function (element) {
        element.classList.remove('btn_disabled');
      });
    }).catch((err) => {
      console.error(err);
    });
  }

  handleChange(e) {
    var member = this.state.member;
    switch (e.target.id) {
      case 'pr':
        member.pr = e.target.value;
    }
    // 状態を更新
    this.setState({ member: member });
  }

  render() {
    function ErrorMessageTag(props) {
      if (props.item && props.message) {
        return <div className="error_massage">{props.item}{props.message}</div>;
      } else if (props.message) {
        return <div className="error_massage">{props.message}</div>;
      } else {
        return '';
      }
    }
    return (
      <React.Fragment>
        <div className="introduction input_group_area">
          <h3 className="fs-113">自己紹介・PR</h3>
          <div className="btn_right mypage_introduction"><a href="" className="fs-75 btn_target" onClick={this.handleClick}>更新</a></div>
          <p className="fs-88-custom">
            <ErrorMessageTag item={'自己紹介・PR'} message={this.props.errors.pr} />
            <textarea id="pr" maxlength="1000" className={this.props.member.pr ? "input_textarea completed" : "input_textarea"} onChange={this.handleChange} defaultValue={this.state.member.pr}></textarea>
          </p>
        </div>
      </React.Fragment>
    );
  }
}

IntroductionEditor.propTypes = { member: PropTypes.object }

export default IntroductionEditor
